"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function reducer(state, action) {
    switch (action) {
        case 'blur':
        case 'closeChoices':
            return Object.assign(Object.assign({}, state), { isFocused: false, areChoicesOpen: false });
        case 'clickOutsideChoices':
            if (!state.isFocused) {
                return Object.assign(Object.assign({}, state), { areChoicesOpen: false });
            }
            return state;
        case 'focus':
            return { areChoicesOpen: true, isEditable: true, isFocused: true };
        case 'clickTag':
        case 'focusChoices':
            return Object.assign(Object.assign({}, state), { areChoicesOpen: true });
        case 'mouseDown':
            return { areChoicesOpen: true, isEditable: true, isFocused: true };
        case 'mouseEnter':
        case 'touchStart':
            return Object.assign(Object.assign({}, state), { isEditable: true });
        default:
            throw new Error(`Unexpected PrettyText reducer type ${action}`);
    }
}
exports.default = reducer;
